import BaseApi from '@/api/rest/base/BaseApi';

export default class GuideApi extends BaseApi {
  static entityName = 'video_guides';
}
